































import { Component, Vue } from "vue-property-decorator";
import firebase from "firebase/app";

@Component
export default class ProfileOpener extends Vue {
  isOpen = false;
  open(): void {
    setTimeout(() => {
      this.isOpen = true;
    }, 0);
  }
  close(): void {
    setTimeout(() => {
      this.isOpen = false;
    }, 50);
  }
  logOut(): void {
    firebase
      .auth()
      .signOut()
      .then(() => {
        console.log("Signed out");
      })
      .catch(error => {
        console.log(error);
      });
  }
  goToAccount(): void {
    if (this.$router.currentRoute.name !== "account")
      this.$router.push({ name: "account" });
  }
}
